import {Tag} from "antd";
import {StyledServiceOrderDrawerOrderInfoOrderTime} from "./styles";
import {
  OrderFilterOptionValueWithoutIncomplete,
  orderStatusTagColors,
  orderStatusTags,
} from "../..";

export type ServiceOrderDrawerOrderInfoOrderTimeProps = {
  orderTime: string;
  status: OrderFilterOptionValueWithoutIncomplete;
};

export function ServiceOrderDrawerOrderInfoOrderTime({
  orderTime,
  status,
}: ServiceOrderDrawerOrderInfoOrderTimeProps) {
  const orderStatus = orderStatusTags[status];

  return (
    <StyledServiceOrderDrawerOrderInfoOrderTime>
      <p className="order-time">{orderTime}</p>
      <Tag color={orderStatusTagColors[status]} title={orderStatus}>
        {orderStatus}
      </Tag>
    </StyledServiceOrderDrawerOrderInfoOrderTime>
  );
}
